import Mixin from '@/mixins/RelationMixin';
const m = new Mixin();

export default {
  priv: 'pr_manage',
  overviewTitle(context) {
    return m.overviewTitles[m.getView(context.$route.path)];
  },
  detailTitle(context) {
    return m.detailTitles[m.getView(context.$route.path)];
  },
  deleteTitle(context) {
    return m.deleteTitles[m.getView(context.$route.path)];
  },
  url(context) {
    return m.urls[m.getView(context.$route.path)];
  },
  fixedFilter(context) {
    return m.fixedFilters[m.getView(context.$route.path)];
  },
  apiUrl: '/businessrelations/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName(context) {
    return m.filterNames[m.getView(context.$route.path)];
  },
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'text'
  },
  newRecord: {
    contacts: [{ index: 0, id: 0 }],
    is_customer: true,
    is_supplier: false,
    is_business: false,
    is_multi_contact: false,
    billing_address: {
      country_id: 56
    }
  },
  tableFields(context) {
    return [
      {
        text: 'Naam',
        value: 'name',
        link: m.urls[m.getView(context.$route.path)] + '/{id}',
        width: '17.5%'
      },
      {
        text: 'Adres',
        value: 'address_street',
        width: '17.5%'
      },
      {
        text: 'Plaats',
        value: 'address_city',
        width: '15%'
      },
      {
        text: 'Telefoonnummer',
        value: 'contact_phone',
        sortable: false,
        width: '15%'
      },
      {
        text: 'E-mailadres',
        value: 'contact_email',
        type: 'email',
        width: '10%',
        align: 'center',
        sortable: false
      },
      {
        text: 'BTW-nummer',
        value: 'vat_number',
        width: '15%',
        sortable: false
      }
    ];
  }
};
